import { config } from "@/config";
const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
});
export const InstrumentoPagoService = {
    // Monedas
    getMonedas: async () => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/monedas`, {
            headers: getHeaders(),
        });
        return await res.json();
    },
    createMoneda: async (moneda) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/monedas`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify(moneda),
        });
        return await res.json();
    },
    updateMoneda: async (id, moneda) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/monedas/${id}`, {
            method: "PUT",
            headers: getHeaders(),
            body: JSON.stringify(moneda),
        });
        return await res.json();
    },
    deleteMoneda: async (id) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/monedas/${id}`, {
            method: "DELETE",
            headers: getHeaders(),
        });
        return await res.json();
    },
    toggleMonedaStatus: async (id) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/monedas/${id}/toggle`, {
            method: "PATCH",
            headers: getHeaders(),
        });
        return await res.json();
    },
    // Instrumentos
    getInstrumentos: async () => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago`, {
            headers: getHeaders(),
        });
        return await res.json();
    },
    createInstrumento: async (instrumento) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify(instrumento),
        });
        return await res.json();
    },
    updateInstrumento: async (id, instrumento) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/${id}`, {
            method: "PUT",
            headers: getHeaders(),
            body: JSON.stringify(instrumento),
        });
        return await res.json();
    },
    deleteInstrumento: async (id) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/${id}`, {
            method: "DELETE",
            headers: getHeaders(),
        });
        return await res.json();
    },
    toggleStatus: async (id) => {
        const res = await fetch(`${config.API_URL}/api/InstrumentoPago/${id}/toggle`, {
            method: "PATCH",
            headers: getHeaders(),
        });
        return await res.json();
    },
};
